import * as React from 'react';

interface TaskJobDetails {
}

interface TaskJobDetailsProps {
    jobDetails: JobDetails;
}

interface JobDetails {
    jobId: number;
    customer: string;
    customerContact: string;
    mobile: string;
    phone: string;
    siteAddress: string;
    lotNumber: string;
}

export default class TaskJobDetail extends React.Component<TaskJobDetailsProps, TaskJobDetails> {
    constructor(props: TaskJobDetailsProps) {
        super(props);

        //this.state = {
            
        //}
        
    }

    render() {
        //let contents = this.state.loading
        //    ? <p><em>Loading...</em></p>
        //    : this.renderDetails();
        let contents = this.renderDetails();

        return <div>
            {contents}
        </div>;
    }

    renderDetails = () => {
        return (
            <div>
                <div>
                    <label className="input-group" htmlFor="jobId">
                        <span className="label">Job Id</span>
                        <input className="input" type="text" id="jobId" name="jobId" value={this.props.jobDetails.jobId} disabled></input>
                    </label>
                </div>
                <div>
                    <label className="input-group" htmlFor="customer">
                        <span className="label">Customer</span>
                        <input className="input" type="text" id="customer" name="customer" value={this.props.jobDetails.customer} disabled></input>
                    </label>
                </div>
                <div>
                    <label className="input-group" htmlFor="siteAddr">
                        <span className="label">Site Address</span>
                        <input className="input" type="text" id="siteAddr" name="siteAddress" value={this.props.jobDetails.siteAddress} disabled></input>
                    </label>
                </div>
                <div>
                    <label className="input-group" htmlFor="lotNumber">
                        <span className="label">Lot Number</span>
                        <input className="input" type="text" id="lotNumber" name="lotNumber" value={this.props.jobDetails.lotNumber} disabled></input>
                    </label>
                </div>
            </div>
        );

    }
}